import { MinutePageHeader } from 'components/minute/layout/MinutePageHeader';
import { MinutePageTitle } from 'components/minute/layout/MinutePageTitle';
import { SetNewPasswordPageContent } from 'components/site/pages/SetNewPasswordPageContent';
import CSS from 'csstype';
import { MinuteWhiteBg } from 'pages/minute/shared/MinuteWhiteBg';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

export interface IProps {
    style?: CSS.Properties;
    className?: string;
}

export const SetNewPasswordPage = (): JSX.Element => {
    return (
        <S_SetNewPasswordPage>
            <S_Center>
                <MinutePageHeader disableLogin={true} />
                <MinutePageTitle
                    title={Localization.RESET_PASSWORD}
                    subtitle={Localization.RESET_PASSWORD_DESC}
                />
                <S_Row>
                    <S_Mid>
                        <SetNewPasswordPageContent />
                    </S_Mid>
                </S_Row>
            </S_Center>
            <MinuteWhiteBg />
        </S_SetNewPasswordPage>
    );
};

const S_SetNewPasswordPage = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    align-items: center;
`;

const S_Center = styled.div`
    display: flex;
    width: 1260px;
    margin: 40px 0 0 0;
    flex-direction: column;
    z-index: 1;
`;

const S_Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const S_Mid = styled.div`
    border-radius: 7px;
    background: #efefef;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);
    width: 400px;
    padding: 20px 20px 0 20px;
`;
